<template>
	<b-container fluid class="p-0">

		<b-row>
			<b-col>
				<edit-base :data="data"/>
			</b-col>
		</b-row>


		<b-row>
			<b-col>
				<edit-subtype :data="data"/>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>

	import SART from "./inspectors/sart";
	import EditBase from "./edit-base";
	import EditSubtype from "./edit-subtype";

	export default {
		props:{
			"data":Object
		},
		components:{
			EditBase,
			EditSubtype
		}
	}
</script>

<style>

</style>